import { render, staticRenderFns } from "./configButton.vue?vue&type=template&id=d70db574&"
import script from "./configButton.vue?vue&type=script&lang=js&"
export * from "./configButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports